import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {VideosComponentComponent} from "./videos-component.component";
import {RouterModule} from "@angular/router";

@NgModule({
  imports: [
    CommonModule, RouterModule
  ],
  declarations: [VideosComponentComponent],
  exports: [VideosComponentComponent]
})
export class VideosComponentModule { }



// WEBPACK FOOTER //
// ./src/app/components/videos-component/videos-component.module.ts